import FormComponent from './components/FormComponent';

function App() {
  return <FormComponent />;
}

export default App;
